export const SHOW_CLIENT_MESSAGE = 'SHOW_CLIENT_MESSAGE';
export const HIDE_CLIENT_MESSAGE = 'HIDE_CLIENT_MESSAGE';
export const SHOW_LOADING = 'SHOW_LOADING';
export const SAVE_BUSINESS_DETAILS = 'SAVE_BUSINESS_DETAILS';
export const SUCCESS_BUSINESS_DETAILS = 'SUCCESS_BUSINESS_DETAILS';
export const FAILED_BUSINESS_DETAILS = 'FAILED_BUSINESS_DETAILS';
